'use strict'; // enforce stricter parsing and error handling

import {setActiveStartItems} from "./_setActiveStartItems.mjs";
//import { updateButtonStates } from "./_buttons.mjs";
import { Disclosure } from './_disclosure.mjs';

const isRTL = document.documentElement.getAttribute('dir') === 'rtl';

/**
 * Tablist
 * @author Jesse de Vries
 */
function Tablist(options) {
    this.Init(options);
    this.options = options;
}

/**
 * Constructor
 * @Param object options
 * @return void
 */

Tablist.prototype = {
    Init: function (options) { // Initialization

        // Default selectors
        const defaultOptions = {
            panels: '.js-tabpanel',
            tabs: '.js-tab',
        }

        // Merge default options with provided options
        this.options = Object.assign({}, defaultOptions, options);

        // Initialize Prototype variables
        this.panels = document.querySelectorAll(this.options.panels);
        this.tabs = document.querySelectorAll(this.options.tabs);

        this.Start();
    },

    /**
     * Start
     * @return void
     */
    // Executes on page load
    Start: function () { // Starting functionality

        const panels = this.panels;
        const tabs = this.tabs;

        panels.forEach(function (panel) {
            panel.setAttribute('tabindex', '0');
        });


        //todo: check if the onloadhandler is necessary, the disclosure script already uses it too
        const onLoadHandler = () => {
            //this.UpdateButtonStates(tabs);
            Disclosure.prototype.UpdateButtonStates.call(Disclosure.prototype, tabs, 'aria-selected');
            this.SetEvents(tabs, panels);
        };

        if (document.readyState === 'complete') {
            // If the document is already loaded, execute immediately
            onLoadHandler();
        } else {
            // Otherwise, add a listener for the 'load' event
            window.addEventListener('load', onLoadHandler);
        }

    },

    /**
     * Update Button States
     * @return void
     */
    // Update the button states
    // todo: We might want to move this function to its own script file that deals with button-related events and import it instead. That way we can always re-use it for other scripts that rely on checking button states. In particular, tab lists use a nearly identical implementation pattern, the only difference being the use of aria-selected on the buttons instead of aria-expanded.
    /*UpdateButtonStates: function (controls) {
        setTimeout( () => { // We set a delay here to make sure all toggleable elements updated their states before the buttons themselves do

            const contentState = 'aria-selected' //todo: does not remove aria-expanded applied by disclosure script
            updateButtonStates(controls, contentState); //todo: should hook into disclosure instead

        });
    },*/

    /**
     * SetEvents
     * @return void
     */
    // Event Handling
    SetEvents: function (tabs, panels) {
        tabs.forEach((tab) => {
            tab.addEventListener('keydown', (e) => {
                e.stopPropagation();

                const tablist = tab.closest('.js-tabs');

                let tabs = Array.from(tablist.querySelectorAll('.js-tab')).filter(tab => {
                    return tablist.contains(tab);
                });

                if (isRTL) {
                    // Reverse the order of tablistControls for RTL mode
                    //tabs.reverse();
                }

                let active = document.activeElement;
                let index = tabs.indexOf(active);
                let first = tabs[0];
                let last = tabs[tabs.length - 1];
                let next = tabs[index + 1];
                let prev = tabs[index - 1];

                //todo: for rtl documents where tabs are horizontally layed-out, the controls should be inverted for the left and right arrows (using aria-orientation as reference, and using isRTL ? '' : '' selector
                switch(e.code) {
                    case 'ArrowDown':
                    case 'ArrowRight':
                        e.preventDefault();
                        if (next) {
                            next.focus();
                            this.fireEvent(next, 'open', e);
                            Disclosure.prototype.fireEvent.call(Disclosure.prototype, next, 'tab', null, tabs);
                        } else {
                            first.focus();
                            this.fireEvent(first, 'open', e);
                            Disclosure.prototype.fireEvent.call(Disclosure.prototype, first, 'tab', null, tabs);
                        }
                        break;

                    case 'ArrowUp':
                    case 'ArrowLeft':
                        e.preventDefault();
                        if (prev) {
                            prev.focus();
                            this.fireEvent(prev, 'open', e);
                            Disclosure.prototype.fireEvent.call(Disclosure.prototype, prev, 'tab', null, tabs);
                        } else {
                            last.focus();
                            this.fireEvent(last, 'open', e);
                            Disclosure.prototype.fireEvent.call(Disclosure.prototype, last, 'tab', null, tabs);
                        }
                        break;

                    case 'Home':
                        e.preventDefault();
                        first.focus();
                        this.fireEvent(first, 'open', e);
                        Disclosure.prototype.fireEvent.call(Disclosure.prototype, first, 'tab', null, tabs);
                        break;

                    case 'End':
                        e.preventDefault();
                        last.focus();
                        this.fireEvent(last, 'open', e);
                        Disclosure.prototype.fireEvent.call(Disclosure.prototype, last, 'tab', null, tabs);
                        break;
                }


            });

            tab.addEventListener('click', (e) => {
                this.fireEvent(tab, 'open', e);
            });

        });

    },

    /**
     * FireEvent
     * @return void
     */
    // Event handling logic
    fireEvent: function (tab, type, e) {

        const tablist = tab.closest('.js-tabs').getAttribute('data-panels'); // Get the nearest '.js-accordion' parent
        const panels = document.getElementById(tablist);

        // Get all opened  panels whose id does not match with the aria-controls attribute of the clicked accordion header // todo: We don't have to worry about looping through multiple aria-controls attributes here because accordion headers can never open more than 1 item at a time, but we should probably throw a warning for headers that have more than 1 string anyway
        const otherContents = panels.querySelectorAll('.js-tabpanel[data-disclosure-content=open]:not([id="' + tab.getAttribute('aria-controls') + '"])');
        if (tab.getAttribute('aria-controls') !== tablist) {

            tab.setAttribute('aria-selected', 'true');
            tab.setAttribute('tabindex', '0');

            otherContents.forEach(function(otherContent) { // Iterate through all non-matching accordion items

                otherContent.setAttribute('data-disclosure-content', 'closed'); // Update their states to 'closed'
                otherContent.classList.remove('active');
                otherContent.classList.remove('transitioning');
                otherContent.removeAttribute('style');

                const masterControl = tab.closest('.js-tabs').querySelector('.js-tab[aria-controls=' + tablist +']');
                setTimeout(function() {
                    if (masterControl) {
                        masterControl.setAttribute('aria-selected', 'false');
                        masterControl.setAttribute('tabindex', '-1');
                    }
                });

            });

        } else {

            //todo: there are numerous problems we need to fix here; it doesn't work properly with arrow key controls, and switching from the master control to another tab doesn't update the button state for the new tab properly the first time.

            // if the pressed tabbutton is the 'master control' tab that opens all tabs at the same time
            const otherContents = panels.querySelectorAll('.js-tabpanel');

            otherContents.forEach(function(otherContent) { // Iterate through all non-matching accordion items
                otherContent.setAttribute('data-disclosure-content', 'open'); // Update their states to 'closed'
                otherContent.classList.remove('active');
                otherContent.classList.remove('transitioning');
                otherContent.removeAttribute('style');

                let animation = otherContent.getAttribute('data-animate');

                if (!animation) {
                    let parentElement = otherContent.closest('[data-animate]');
                    if (parentElement) {
                        animation = parentElement.getAttribute('data-animate');
                    }
                }

                Disclosure.prototype.SetAnimation.call(Disclosure.prototype, otherContent, animation);

                const otherTabs = tab.closest('.js-tabs').querySelectorAll('.js-tab:not([aria-controls="' + tab.getAttribute('aria-controls') + '"])');
                setTimeout(function() {
                    tab.setAttribute('aria-selected', 'true');
                    tab.setAttribute('tabindex', '0');
                    otherTabs.forEach(function (otherTab) {
                        otherTab.setAttribute('aria-selected', 'false');
                        otherTab.setAttribute('tabindex', '-1');
                    });
                });

            });
        }

    }

}

export { Tablist };
